import styled from 'styled-components';
import { theme } from '../config/theme';

export const PageContainer = styled.div`
  padding: ${theme.spacing.xl} ${theme.spacing.sectionPadding.horizontal};
  background-color: ${theme.colors.primary.background};
  padding-top: calc(var(--nav-height, 128px) + ${theme.spacing.xl});
  padding-bottom: ${theme.spacing.md};
`;

export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-family: ${theme.typography.primary.fontFamily};
  font-size: ${theme.typography.primary.heading.fontSize};
  font-weight: ${theme.typography.primary.heading.fontWeight};
  line-height: ${theme.typography.primary.heading.lineHeight};
  color: ${theme.colors.primary.text};
  margin-bottom: ${theme.spacing.xl};
  text-align: center;
`;

export const Section = styled.section`
  margin-bottom: ${theme.spacing.xl};
`;

export const SectionTitle = styled.h2`
  font-family: ${theme.typography.primary.fontFamily};
  font-size: ${theme.typography.primary.smallHeading.fontSize};
  font-weight: ${theme.typography.primary.smallHeading.fontWeight};
  color: ${theme.colors.primary.text};
  margin-bottom: ${theme.spacing.lg};
`;

export const Paragraph = styled.p`
  font-family: ${theme.typography.secondary.fontFamily};
  font-size: ${theme.typography.secondary.body.fontSize};
  font-weight: ${theme.typography.secondary.body.fontWeight};
  line-height: ${theme.typography.secondary.body.lineHeight};
  color: ${theme.colors.primary.text};
  margin-bottom: ${theme.spacing.lg};
`;

export const List = styled.ul`
  font-family: ${theme.typography.secondary.fontFamily};
  font-size: ${theme.typography.secondary.body.fontSize};
  line-height: ${theme.typography.secondary.body.lineHeight};
  color: ${theme.colors.primary.text};
  margin-bottom: ${theme.spacing.lg};
  padding-left: ${theme.spacing.lg};
`;

export const ListItem = styled.li`
  margin-bottom: ${theme.spacing.sm};
`;

export const LastUpdated = styled.div`
  font-family: ${theme.typography.secondary.fontFamily};
  font-size: 0.9rem;
  color: ${theme.colors.primary.text};
  opacity: 0.7;
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
  font-style: italic;
`;